export const AUTH_INPUT_CLASS =
  'h-[50px] w-full rounded border border-unilink-border-outline px-4 py-3 text-base leading-6 text-unilink-text-primary focus:border-unilink-text-primary focus:outline-none focus:ring-0';

export const AUTH_PASSWORD_INPUT_CLASS = `${AUTH_INPUT_CLASS} auth-password-input-no-reveal pr-12`;
